// System dependencies

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Application dependencies

import {
  Authorisation,
  AuthorisationFields,
  AuthorisationRedux,
} from "@/interfaces/authorisation/authorisation.interfaces";
import { RootState } from "@/redux/store";

// State

const initialState: AuthorisationRedux = {
  [AuthorisationFields.Authorisation]: null,
};

const authorisationSlice = createSlice({
  name: "authorisation",
  initialState: initialState,
  reducers: {
    authorisationLoadAuthorisation: (
      state,
      action: PayloadAction<Authorisation | null>
    ) => {
      state[AuthorisationFields.Authorisation] = action.payload;
    },
  },
});

export const { authorisationLoadAuthorisation } = authorisationSlice.actions;

export const getAuthorisationSelector = (state: RootState) =>
  state.authorisation;

export default authorisationSlice.reducer;
